import { loader } from 'graphql.macro'

export default function termsAndConditions ({ dataLoaders, queryKey }) {
  const [, variables] = queryKey
  const termsAndConditionsSchema = loader('./termsAndConditions.graphql')
  return dataLoaders.dispatcher.graphQLClient.request(termsAndConditionsSchema, {
    haulerId: variables.haulerId,
    isEnabled: variables.isEnabled,
    forAssignment: variables.forAssignment
  })
}
